import Backend from 'App/Dataman-Backend';

const { apiUrlProductBrands, apiUrlBrandImages, apiUrlSuffix } = Backend.config;

export const BRANDS_PATHS = {
  brands: apiUrlProductBrands,
  images: apiUrlBrandImages,
  suffix: apiUrlSuffix,
};
